import { uploadImage } from "./MediaAPI";
import { apiRequest } from "./httpClient";

export async function createGroup(username, token, name) {
    return apiRequest("api/groups/create", { token, body: { username, name } });
}

export async function inviteMember(username, token, groupId, invitedUsername) {
    return apiRequest("api/groups/invite-member", { token, body: { username, groupId, invitedUsername } });
}

export async function listIncomingInvites(username, token) {
    return apiRequest("api/groups/list-incoming-invites", { token, body: { username } });
}

export async function acceptInvite(username, token, inviteId) {
    return apiRequest("api/groups/accept-invite", { token, body: { username, inviteId } });
}

export async function declineInvite(username, token, inviteId) {
    return apiRequest("api/groups/decline-invite", { token, body: { username, inviteId } });
}

export async function leaveGroup(username, token, groupId) {
    return apiRequest("api/groups/leave", { token, body: { username, groupId } });
}

export async function deleteGroup(username, token, groupId) {
    return apiRequest("api/groups/delete", { token, body: { username, groupId } });
}

export async function removeMember(username, token, groupId, targetUsername) {
    return apiRequest("api/groups/remove-member", { token, body: { username, groupId, targetUsername } });
}

export async function listMyGroups(username, token) {
    return apiRequest("api/groups/list-my-groups", { token, body: { username } });
}

export async function listMembers(username, token, groupId) {
    return apiRequest("api/groups/list-members", { token, body: { username, groupId } });
}

export async function listRooms(username, token, groupId) {
    return apiRequest("api/groups/list-rooms", { token, body: { username, groupId } });
}

export async function getAuditLog(username, token, groupId) {
    return apiRequest("api/groups/audit-log", { token, body: { username, groupId } });
}

// Same media pipeline as the avatar (MediaAPI.uploadImage): square crop,
// processed server-side, so a GIF icon keeps its animation.
export async function changeGroupImage(groupId, file, crop, onProgress) {
    return uploadImage("api/groups/update-image", { file, crop, fields: { groupId }, onProgress });
}

export async function deleteGroupImage(username, token, groupId) {
    return apiRequest("api/groups/delete-image", { token, body: { username, groupId } });
}
